<template>
  <div class="basket-item">
    <div class="basket-item__inner">
      <div class="basket-item__content">
        <!--        <div-->
        <!--          class="basket-item__delete"-->
        <!--          @click.prevent="deleteProduct(basketItem.specificId)"-->
        <!--        >-->
        <!--          <svg xmlns="http://www.w3.org/2000/svg">-->
        <!--            <use xlink:href="#ico-bin"></use>-->
        <!--          </svg>-->
        <!--        </div>-->
        <router-link :to="productLink"
                     class="basket-item__img">
          <img :src="product.image_preview" :alt="product.name"/>
        </router-link>

        <div class="basket-item__title">
          <router-link
            :to="productLink">
            {{ product.name }}
          </router-link>
        </div>
      </div>
      <div class="basket-item__price">
        <div class="basket-item__price-item">
          <div class="basket-item__price-val">
            {{ oneCurrentBasketItemPrice | formatPrice }} {{ $t('грн') }}
          </div>
          <div class="basket-item__price-val _small"
               v-if="basketItem.variant && basketItem.variant.packaging_price">
            {{ $t('Пакування') }}: <b>{{ basketItem.variant.packaging_price | formatPrice }}
            {{ $t('грн') }}</b></div>
        </div>
        <div class="basket-item__price-item _quantity">
          <Quantity
            :value="basketItem.quantity"
            @input="onChangeProductQuantity"
          />
        </div>
        <div class="basket-item__price-item _total">
          <div class="basket-item__price-val">
            <span class="d-none d-sm-inline">{{ $t('Загалом') }}:&nbsp;</span>{{
              (oneCurrentBasketItemPrice + basketItem.variant.packaging_price) * basketItem.quantity | formatPrice
            }} {{ $t('грн') }}
          </div>
        </div>
        <div
          class="basket-item__delete"
          @click.prevent="deleteProduct(basketItem.specificId)"
        >
          <svg xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="#ico-bin"></use>
          </svg>
        </div>
      </div>
    </div>

    <div class="basket-item__description">
      <div v-if="basketItem.variant.name"
           class="basket-item__description-row">
        <template v-if="settings && settings.pizzaCategoryId == product.category.id">
          <b>{{ $t('Розмір') }}:</b>
        </template>
        <template v-else>
          <b>{{ $t('Варіант') }}:</b>
        </template>
        &nbsp;<span>{{ basketItem.variant.name }}</span>
      </div>
      <div v-if="basketItem.property"
           class="basket-item__description-row">
        <b>{{ $t('Соус') }}:</b>&nbsp;
        <span>{{ basketItem.property.property }}</span>
      </div>
      <div v-if="basketItem.main_ingredients && Object.keys(basketItem.main_ingredients).length"
           class="basket-item__description-row">
        <b>{{ $t('Основні інгредієнти') }}:</b>&nbsp;
        <AdditionalTags inline
                        :ingredients="basketItem.main_ingredients"/>
      </div>
      <div
        v-if="basketItem.additional_ingredients && Object.keys(basketItem.additional_ingredients).length"
        class="basket-item__description-row">
        <b>{{ $t('Додаткові інгредієнти') }}:</b>&nbsp;
        <AdditionalTags inline
                        :ingredients="basketItem.additional_ingredients"/>
      </div>
      <div v-if="basketItem.comment"
           class="basket-item__description-row">
        <b>{{ $t('Коментар') }}:</b>&nbsp;
        <span>{{ basketItem.comment }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import getBasketItemPrice from '@/helpers/getBasketItemPrice'
import Quantity from './Quantity'
import AdditionalTags from '@/components/AdditionalTags'

export default {
  name: 'basket-item',
  components: {
    AdditionalTags,
    Quantity
  },
  props: {
    basketItem: {
      type: Object,
      required: true,
    },
  },
  data(vm) {
    return {
      product: vm.basketItem.product,
    }
  },
  computed: {
    ...mapState('settings', ['settings']),
    oneCurrentBasketItemPrice() {
      return getBasketItemPrice(this.basketItem)
    },
    productLink() {
      if (this.product.type === 'classic') {
        return {name: 'product', params: {id: 'classic'}}
      }
      return {name: 'product', params: {id: this.product.id}}
    }
  },
  methods: {
    ...mapMutations('basket', ['deleteProduct', 'changeProductQuantity']),
    onChangeProductQuantity(value) {
      this.changeProductQuantity({
        specificId: this.basketItem.specificId,
        newQuantity: value,
      })
    },
  },
}
</script>

